import React from 'react';

function ChosenPassengerDetail({ title, text }) {
  return (
    <div className="flex flex-col gap-[13px] font-medium text-xl">
      <span className="font-bold text-base">{title}</span>
      {text}
    </div>
  );
}

export default ChosenPassengerDetail;
